ACC.cartReminder = {
  flagValue: $('.ph-cartReminderPopup__Flag').html(),

  cartReminderPopupMain: function() {
    if (sessionStorage.getItem('cartReminderPopup') !== 'shown') {
      ACC.cartReminder.cartReminderPopupSubFunction();
    }
  },

  cartReminderPopupSubFunction: function() {
    sessionStorage.setItem('cartReminderPopup', 'shown');

    if (ACC.cartReminder.flagValue === 'true') {
      ACC.cartReminder.cartReminderShowPopUp();
    }
  },

  cartReminderShowPopUp: function() {
    $.colorbox({
      html: $('.ph-cartReminder__Wrapper').html(),
      maxWidth: '522px',
      width: '100%',
      height: 'auto',
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      onComplete: function() {
        $(document).on('click', '.ph-cartReminder__closeButton, .ph-cartReminder__viewYourCart', function() {
          $.colorbox.close();
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  }
};

$(function() {
  if ($('.ph-isOneStore').html() === 'true') {
    if ($('.ph-loggedIn').length <= 0) {
      sessionStorage.removeItem('cartReminderPopup');
    }

    if ($('.ph-loggedIn').length > 0) {
      var passwordPopupNotShown = $('.ph-encodedType').attr('data-encodeValue');

      if (passwordPopupNotShown === '' || passwordPopupNotShown === 'false') {
        ACC.cartReminder.cartReminderPopupMain();
      }
    }
  }
});
